import React, { useEffect, useState } from "react";
import { About } from "./components/about";
import { Features } from "./components/features";
import { Gallery } from "./components/gallery";
import { Header } from "./components/header";
import { Marcas } from "./components/Marcas";
import { Navigation } from "./components/navigation";
import { Services } from "./components/services";
import { Map } from "./components/map";

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import SmoothScroll from "smooth-scroll";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";

import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);


  //ORDEN DE LOS COMPONENTES EN LA PÁGINA
  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Gallery data={landingPageData.Gallery} />
      <Marcas data={landingPageData.Marcas} />
      <Map data={landingPageData.Map} />
      <Contact data={landingPageData.Contact} />
      
    </div>
  );
};

export default App;
